module.exports = __webpack_public_path__ + "img/user_icon.ba994ada.svg";